import React, {useEffect, useState} from 'react';
import {throttle} from '../../utils/util';

interface IUseScroll {
  bottomDistance?:number;
  onTouchBottom:()=>void;
  onScroll?:(e:any)=>void;
  wait?:number;
}

export default (props:IUseScroll)=>{
  const [wrapper, setWrapper] = useState(null as any);

  const {bottomDistance = 1000, onTouchBottom, onScroll, wait = 150} = props;
  useEffect(()=>{
    let maxScroll = 0;
    const onScrollEvent = throttle((e:any)=>{
      if(e && e.target) {
        if(onScroll) {
          onScroll(e);
        }
        const {offsetHeight, scrollTop, scrollHeight} = e.target;
        if((offsetHeight + scrollTop + bottomDistance) >= scrollHeight) {
          // 快要到底了
          if(maxScroll < scrollTop) {
            onTouchBottom && onTouchBottom();
          }
          maxScroll = scrollTop;
        }
      }
    }, wait);

    if(wrapper && wrapper.current) {
      wrapper.current.addEventListener('scroll', onScrollEvent);
    }

    return ()=>{
      if(wrapper && wrapper.current) {
        wrapper.current.removeEventListener('scroll', onScrollEvent);
      }
    }
  }, [wrapper]);

  return {
    setWrapper
  }
}
